export default {"src":"/_next/static/media/spotme-mark.dddca475.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};